import {
  CREATE_DEVICE_API,
  DECOMMISSION_DEVICE_API,
  DELETE_DEVICE_API,
  EXPORT_DEVICES_API,
  GET_DECOMMISSION_INFO_API,
  GET_DEVICE_CREATION_INFO_API,
  GET_DEVICE_DETAIL_API,
  GET_IS_LICENSE_OTAP_API,
  GET_MATCHING_GROUP_DEVICE_API,
  MOVE_TO_GROUP_API,
  SEACRH_DEVICE_API,
  UPDATE_DEVICE_API,
  COMMIT_DEVICE_API,
  GET_DEVICE_OTAP_STATE_API
} from '~/constants/APIs'
import {
  DeviceDetailType,
  IDeviceSearchRequest,
  ISearchDeviceResponse,
  IResponseSearchResults,
  IDecommissionInfo,
  IDecommissionDeviceRequest,
  GroupDetailSummaryType,
  DetailOtapStateType
} from '~/models'
import { NewDeviceFormType } from '~/pages/Devices/components/DeviceCreation'
import { EditDeviceFormType } from '~/pages/Devices/DeviceDetail'
import axiosClient from './axiosClient'
import { ExportDevicesRequestType } from '~/pages/Devices/Device.model'

export const deviceApis = {
  searchDevices: (params: IDeviceSearchRequest) =>
    axiosClient.get(SEACRH_DEVICE_API, { params }).then((data: any) => {
      if (data.results) return { results: data.results }
      return { results: data as ISearchDeviceResponse }
    }) as unknown as IResponseSearchResults,

  getDetails: (deviceId: number) =>
    axiosClient.get(GET_DEVICE_DETAIL_API + deviceId) as unknown as DeviceDetailType,

  exportDevices: (data: ExportDevicesRequestType) =>
    axiosClient.post(EXPORT_DEVICES_API, data, { responseType: 'blob' }),

  updateDevice: (data: EditDeviceFormType) =>
    axiosClient.put(UPDATE_DEVICE_API + data.deviceId, data),

  commitDevice: (data: EditDeviceFormType) => axiosClient.put(COMMIT_DEVICE_API, data),

  deleteDevice: (data: { otapIds: string[] }) =>
    axiosClient.delete(DELETE_DEVICE_API, { data }),

  createDevice: (data: NewDeviceFormType) => axiosClient.post(CREATE_DEVICE_API, data),

  getDeviceCreationInfo: (groupOtapId: number) =>
    axiosClient.get(GET_DEVICE_CREATION_INFO_API, {
      params: { groupOtapId }
    }) as unknown as DeviceDetailType,

  getMatchingGroupDevice: (groupId: number | null) =>
    axiosClient.get(GET_MATCHING_GROUP_DEVICE_API, {
      params: { groupId }
    }) as unknown as GroupDetailSummaryType[],

  moveToGroup: (data: {
    targetGroupId: number | null
    deviceIds: string[]
    allowChangeCustomizationProfile: boolean
  }) => axiosClient.post(MOVE_TO_GROUP_API, data),

  getIsLicenseForOtap: () =>
    axiosClient.get(GET_IS_LICENSE_OTAP_API) as unknown as { isLicenseForOtap: boolean },

  getDecommissionInfo: (serialNumbers: string[]) =>
    axiosClient.get(GET_DECOMMISSION_INFO_API, {
      params: { serialNumbers }
    }) as Promise<IDecommissionInfo>,

  decommissionDevice: (data: IDecommissionDeviceRequest) =>
    axiosClient.post(DECOMMISSION_DEVICE_API, data),

  getDeviceOtapState: (
    deviceId?: number | null,
    deployingManifestId?: number | null,
    deviceOtapStateId?: number | null
  ) =>
    axiosClient.get(GET_DEVICE_OTAP_STATE_API + deviceId + '/GetDeviceDetailOtapState', {
      params: { deployingManifestId, deviceOtapStateId }
    }) as unknown as DetailOtapStateType
}
